export enum contactTypeCode{
"IVRP"="data.Code.Patient_Call_Contact_Type_Cd.Code_Desc.IVRP",
"SMSP"="data.Code.Patient_Call_Contact_Type_Cd.Code_Desc.SMSP",
"SMSO"="data.Code.Patient_Call_Contact_Type_Cd.Code_Desc.SMSO",
"NONE"="data.Code.Patient_Call_Contact_Type_Cd.Code_Desc.NONE"
}